var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],ref:_vm.id,staticStyle:{"height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }